<template>
    <a-drawer
        title="公式预设"
        placement="right"
        :visible="visible"
        :width="380"
        :mask="false"
        :wrapStyle="{ marginTop: '0px' }"
        @close="handleClose"
    >
        <!-- 语法说明 -->
        <div class="formula-help">
            <a-alert type="info" show-icon banner>
                <template slot="message">
                    <span>点击下方公式插入到当前单元格<b>光标位置</b>。整体公式请用 <code>\</code> 包裹。</span>
                </template>
                <div class="help-detail" slot="description">
                    <div><code>t/yyyyMMdd/</code> 日期 &nbsp; <code>(n)</code> n位数字</div>
                    <div><code>{n}</code> 小写字母 &nbsp; <code>&lt;n&gt;</code> 大写字母</div>
                    <div><code>[n]</code> 数字+大写 &nbsp; <code>`n`</code> 数字+小写</div>
                    <div><code>{姓名}</code> 随机姓名 &nbsp; <code>c/字段/</code> 列引用</div>
                </div>
            </a-alert>
        </div>

        <a-spin :spinning="loading">
            <a-empty v-if="!grouped.length" description="暂无公式" />
            <div v-else>
                <div v-for="group in grouped" :key="group.category" class="formula-group">
                    <div class="group-title">{{ group.category }}</div>
                    <a-list size="small" :data-source="group.items" :split="false">
                        <a-list-item slot="renderItem" slot-scope="item" class="formula-item" @click="handleSelect(item)">
                            <a-list-item-meta>
                                <span slot="title">{{ item.name }}</span>
                                <code slot="description" class="formula-content">{{ item.content }}</code>
                            </a-list-item-meta>
                            <a-icon type="plus-circle" class="insert-icon" />
                        </a-list-item>
                    </a-list>
                </div>
            </div>
        </a-spin>
    </a-drawer>
</template>

<script>
import { API } from '@/config/api'
import request from '@/utils/request'
import { formulaPresets } from '@/config/formulaPresets'

export default {
    name: 'FormulaPanel',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            list: []
        }
    },
    computed: {
        // 按 category 分组
        grouped() {
            const map = {}
            this.list.forEach(item => {
                const cat = item.category || '其它'
                if (!map[cat]) map[cat] = { category: cat, items: [] }
                map[cat].items.push(item)
            })
            // 保持 category 出现顺序按 sort
            return Object.values(map).sort((a, b) => {
                const sa = a.items[0]?.sort ?? 0
                const sb = b.items[0]?.sort ?? 0
                return sa - sb
            })
        }
    },
    watch: {
        visible(val) {
            if (val && !this.list.length) this.fetchList()
        }
    },
    methods: {
        async fetchList() {
            this.loading = true
            try {
                const res = await request.get(API.FORMULA_LIST)
                // request 拦截器在 code===1 时返回 {code,msg,data}，data 为公式数组
                const data = res && res.data
                if (Array.isArray(data) && data.length) {
                    this.list = data
                } else {
                    // 兜底：用本地预设
                    this.list = formulaPresets
                }
            } catch (e) {
                console.warn('[FormulaPanel] 接口获取失败，使用本地兜底清单', e)
                this.list = formulaPresets
            } finally {
                this.loading = false
            }
        },
        handleSelect(item) {
            this.$emit('select', item.content)
        },
        handleClose() {
            this.$emit('update:visible', false)
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.formula-help {
    margin-bottom: 16px;
}
.help-detail {
    margin-top: 6px;
    line-height: 1.9;
}
.help-detail code,
.formula-content {
    font-family: 'Menlo', 'Consolas', monospace;
    background: #f5f5f5;
    padding: 1px 4px;
    border-radius: 3px;
    color: #c41d7f;
    font-size: 12px;
}
.formula-group {
    margin-bottom: 18px;
}
.group-title {
    font-weight: 600;
    color: #1890ff;
    border-left: 3px solid #1890ff;
    padding-left: 8px;
    margin-bottom: 8px;
}
.formula-item {
    cursor: pointer;
    padding: 6px 8px !important;
    border-radius: 4px;
    transition: background 0.2s;
}
.formula-item:hover {
    background: #e6f7ff;
}
.insert-icon {
    color: #1890ff;
    font-size: 16px;
}
</style>
